module.exports = __webpack_public_path__ + "static/media/United-Airlines.038f3328.gif";